export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4600.9a20e923.jpg";